export default {
    es: 'spain.png',
    en: 'united-kingdom.png',
    de: 'germany.png',
    fr: 'france.png',
    it: 'italy.png',
}